// Ported from job-specification.component.ts's parseRawDataToSections() -
// simpler than JobSpecComparison.jsx's version (no common-point highlighting
// needed here, single role only) - points are plain strings, not {text} objects.
// Shared by JobSpecPanel.jsx and the Job Description Word/Excel export.
export function parseJobDescriptionSections(rawText) {
  if (!rawText) return [];
  const lines = String(rawText).split(/\r?\n/).map((l) => l.trim()).filter(Boolean);
  const sections = [];
  let current = null;
  let inSection = false;
  const introLines = [];

  for (const line of lines) {
    if (line.endsWith(":")) {
      inSection = true;
      current = { title: line.slice(0, -1).trim(), points: [] };
      sections.push(current);
    } else if (/^[•\-–●]/.test(line)) {
      const point = line.replace(/^[•\-–●]\s*/, "").trim();
      if (current) {
        current.points.push(point);
      } else {
        current = { title: "", points: [point] };
        sections.push(current);
      }
      inSection = true;
    } else if (!inSection) {
      introLines.push(line);
    }
  }
  if (introLines.length) {
    sections.unshift({ title: "Summary", points: [introLines.join(" ")] });
  }
  return sections;
}
